
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class ApprovalOutItemsSelectGrid extends _Ext.GridBase<ApprovalOutItemsRow,any> {
        protected getColumnsKey() { return 'Sales.ApprovalOutItemsSelect'; }
        protected getDialogType() { return <any>ApprovalOutItemsDialog; }
        protected getIdProperty() { return ApprovalOutItemsRow.idProperty; }
        protected getLocalTextPrefix() { return ApprovalOutItemsRow.localTextPrefix; }
        protected getService() { return Sales.ApprovalOutItemsService.baseUrl; }
         
        constructor(container: JQuery,options) {
            super(container, options);
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.addQuickFilter({

                type: Retail.TempEditor,
                title: "",
                separator: false, field: "ItemTypeId"

            });

            let propertyName: string = "s-TempEditor s-Retail-TempEditor";
            let radioElement: JQuery = $("[class$='" + propertyName + "']").find("label");
            let item1 = radioElement[0];
            let item2 = radioElement[1];
            let item3 = radioElement[2];

            //item1.setAttribute("style", "padding-left:30px;");
            item1.setAttribute("style", "font-weight: normal;");
            item2.setAttribute("style", "padding-left:50px; font-weight: normal;");
            item3.setAttribute("style", "padding-left:50px;font-weight: normal;");

            //var quickFilterElem = this.element.find('s-TempEditor s-Retail-TempEditor')
            //var quickfilterparent = this.element.find('s-TempEditor s-Retail-TempEditor').parent();

            //quickfilterparent.remove(propertyName);
            //var myNewParent = this.element.find()
            //myNewParent.Add(add(quickFilterElem);

            return this;
        }

        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize(); // *** If you want to make it autoresize when grid is loaded, use: new Slick.AutoColumnSize(true);
            grid.registerPlugin(this.autoSize);
            return grid;
        }

        protected createToolbarExtensions(): void {
            super.createToolbarExtensions()

        }
        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 20;
            return opt;
        }

        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): ApprovalOutItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return true; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            var request = this.view.params;
            var itemtype = request.EqualityFilter.ItemTypeId;


            this.view.beginUpdate();

            let filter = function filter(item, args) {
                var linha = (item as Sales.ApprovalOutItemsRow);
                if (itemtype == undefined) {
                    if (item["ItemTypeId"] == "101")
                        return true;
                }
                else if (itemtype == "101") {
                    if (item["ItemTypeId"] == "101")
                        return true;
                }
                else if (itemtype == "104") {
                    if (item["ItemTypeId"] == "104")
                        return true;
                }
                else if (itemtype == "105") {
                    if (item["ItemTypeId"] == "105")
                        return true;
                }
                return false;
            }

            this.view.setFilter(filter);

            this.view.endUpdate();
            return true;

        }


    } 
}